Ext.define('SA.SectionedTable', {
    tpl: [
        '<tr class="sa-sectioned-table-row">',
            '<td></td>', 
            '<td>',
                '<div class="sa-sectioned-table-top"></div>',
            '</td>',
            '<td></td>', 
        '</tr>',
        '<tr class="sa-sectioned-table-row">',
            '<td>',
                '<div class="sa-sectioned-table-left"></div>',
            '</td>',
            '<td rowspan="2" colspan="2">',
                '<div class="sa-sectioned-table-body"></div>',
            '</td>',
        '</tr>',
        '<tr class="sa-sectioned-table-row">',
            '<td></td>', 
        '</tr>'
    ],

    constructor({parent, cellsCaches}) {
        this.el = parent.appendChild(document.createElement('table'));
        this.el.innerHTML = this.tpl.join('');
        this.el.className = 'sa-sectioned-table';

        this.top = new SA.TableTopSection({cellsCache: cellsCaches.top, el: this.el.querySelector('.sa-sectioned-table-top')});
        this.left = new SA.TableLeftSection({cellsCache: cellsCaches.left, el: this.el.querySelector('.sa-sectioned-table-left')});
        this.body = new SA.TableBodySection({cellsCache: cellsCaches.body, el: this.el.querySelector('.sa-sectioned-table-body')});

        this.on('section:userscroll', this.onSectionScroll, this);
    },

    destroy() {
        this.el.remove();
        this.el = null;

        this.callParent();
    },

    dispatch(eventType, detail = null) {
        this.el.dispatchEvent(new CustomEvent(eventType, {detail}));
    },

    getLeftBox() {
        return this.left.getBox();
    },

    getLeftCells() {
        return this.left.getCells();
    },

    getScrollability() {
        return this.body.getScrollability();
    },

    getScrollRect() {
        return this.body.getScrollRect();
    },

    getTopBox() {
        return this.top.getBox();
    },

    getTopCells() {
        return this.top.getCells();
    },

    on(event, callback, scope) {
        this.el.addEventListener(event, callback.bind(scope));
    },

    onSectionScroll(ev) {
        var section = ev.detail.section;

        if (section.isTop()) {
            this.body.setScrollLeft(this.top.getScrollLeft());
        }
        else if (section.isLeft()) {
            this.body.setScrollTop(this.left.getScrollTop());
        }
        else {
            this.top.setScrollLeft(this.body.getScrollLeft());
            this.left.setScrollTop(this.body.getScrollTop());
        }

        this.dispatch('userscroll');
    },

    scrollBy([xDelta, yDelta]) {
        this.top.scrollBy(xDelta, 0);
        this.left.scrollBy(0, yDelta);
        this.body.scrollBy(xDelta, yDelta);
    },

    setContainerSizes({constrainedSize, leftWidth, topHeight, hasScrollX, hasScrollY}) {
        var scrollbarSize = Ext.getScrollbarSize(),
            bodyWidth = constrainedSize.width - leftWidth,
            bodyHeight = constrainedSize.height - topHeight,
            topWidth = hasScrollY ? (bodyWidth - scrollbarSize.width) : bodyWidth,
            leftHeight = hasScrollX ? (bodyHeight - scrollbarSize.height) : bodyHeight;

        this.top.setContainerSize({height: topHeight, width: topWidth});
        this.left.setContainerSize({width: leftWidth, height: leftHeight});
        this.body.setContainerSize({width: bodyWidth, height: bodyHeight});
    },

    setFrameData({top, left, body}) {
        var rowCount = left.length,
            columnCount = top.length;

        this.top.setRowAndColumnCount({rowCount: 1, columnCount});
        this.left.setRowAndColumnCount({rowCount, columnCount: 1});
        this.body.setRowAndColumnCount({rowCount, columnCount});

        this.top.setData(top);
        this.left.setData(left);
        this.body.setData(body);
    },

    setFrameOffset({top, left}) {
        this.top.setFrameOffset({top: 0, left});
        this.left.setFrameOffset({top, left: 0});
        this.body.setFrameOffset({top, left});
    },

    setIntrinsicSizes({intrinsicSize, leftWidth, topHeight}) {
        var bodyWidth = intrinsicSize.width - leftWidth,
            bodyHeight = intrinsicSize.height - topHeight;

        this.top.setIntrinsicSize({height: topHeight, width: bodyWidth});
        this.left.setIntrinsicSize({width: leftWidth, height: bodyHeight});
        this.body.setIntrinsicSize({width: bodyWidth, height: bodyHeight});
    },

    setSizing(sizing) {
        if (JSON.stringify(sizing) === this.lastSizing) {
            return;
        }

        this.lastSizing = JSON.stringify(sizing);

        this.setContainerSizes(sizing);
        this.setIntrinsicSizes(sizing);
    }
});